import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AngularMaterialModule } from '../../angular-material.module';
import { CheckoutService } from '../checkout.service';

@Component({ selector: 'app-payment-success', standalone: true, imports: [CommonModule, RouterModule, AngularMaterialModule], templateUrl: './payment-success.component.html', styleUrls: ['./payment-success.component.css'] })
export class PaymentSuccessComponent implements OnInit, OnDestroy {
  isLoading = true;
  registrationComplete = false;
  statusMessage = 'Verifying your payment...';
  registrationType: 'team' | 'player' = 'team';
  teamName = '';
  captainName = '';
  captainEmail = '';
  divisionName = '';
  playerName = '';
  playerEmail = '';
  season = '';
  paymentType = '';
  amountPaid = 0;
  jerseyQuantity = 0;
  recoveryNeeded = false;
  private sessionId = '';
  private pollAttempt = 0;
  private pollTimer?: ReturnType<typeof setTimeout>;
  private destroyed = false;
  private readonly pollDelays = [1500, 2500, 4000, 6000, 8000];

  constructor(private checkoutService: CheckoutService, private router: Router) {}

  ngOnInit(): void {
    const sessionId = new URLSearchParams(window.location.search).get('session_id');
    if (sessionId) {
      this.sessionId = sessionId;
      void this.verifyPaymentAndGetDetails(sessionId);
    }
    else void this.router.navigate(['/register']);
  }

  async verifyPaymentAndGetDetails(sessionId: string): Promise<void> {
    try {
      const response = await this.checkoutService.getSessionStatus(sessionId);
      if (response.status !== 'complete' || response.payment_status !== 'paid') { void this.router.navigate(['/register']); return; }
      if (response.registration_status !== 'complete') {
        this.statusMessage = 'Payment confirmed. Finishing your registration…';
        if (this.pollAttempt >= this.pollDelays.length) {
          this.isLoading = false;
          this.recoveryNeeded = true;
          this.statusMessage = 'Your payment is confirmed, but registration is taking longer than expected.';
          return;
        }
        const delay = this.pollDelays[this.pollAttempt++];
        this.pollTimer = setTimeout(() => {
          this.pollTimer = undefined;
          if (!this.destroyed) void this.verifyPaymentAndGetDetails(sessionId);
        }, delay);
        return;
      }
      this.registrationType = response.registration_type || 'team';
      this.teamName = response.team_name || '';
      this.divisionName = response.division_name || '';
      this.season = response.season_name || '';
      this.paymentType = response.payment_type || (this.registrationType === 'player' ? 'full' : '');
      this.amountPaid = response.amount_total ? response.amount_total / 100 : 0;
      this.jerseyQuantity = response.jersey_quantity || 0;
      this.registrationComplete = true;
      this.isLoading = false;
    } catch { void this.router.navigate(['/register']); }
  }

  retryVerification(): void {
    if (!this.sessionId || this.destroyed) return;
    if (this.pollTimer) clearTimeout(this.pollTimer);
    this.pollTimer = undefined;
    this.pollAttempt = 0;
    this.recoveryNeeded = false;
    this.isLoading = true;
    this.statusMessage = 'Checking your registration again…';
    void this.verifyPaymentAndGetDetails(this.sessionId);
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    if (this.pollTimer) clearTimeout(this.pollTimer);
    this.pollTimer = undefined;
  }
}
